import * as React from 'react';
import cn from 'classnames';

import { Step as StepType, StepVariant } from '../../types';
import { useTheme } from '../../../../theme';

interface Props {
	id: number;
	step: StepType;
	isActive?: boolean;
	isPassed?: boolean;
	isDisabled?: boolean;
	variant?: StepVariant;
}

const Step: React.FunctionComponent<Props> = ({
	step,
	isActive = false,
	isPassed = false,
	isDisabled = false,
	variant,
	id
}) => {
	const { Step: css } = useTheme('Stepbar');

	const isClickable = isPassed && !isDisabled && !!step.onClick;

	return (
		<div
			className={cn(css.step, {
				[css.step_active]: isActive,
				[css.step_passed]: isPassed,
				[css.step_clickable]: isClickable,
				[css.step_disabled]: isDisabled,
				[css.step_textOnly]: variant === 'textOnly',
				[css.step_expanded]: variant === 'expanded'
			})}
			onClick={isClickable ? step.onClick : null}
		>
			{step.icon && <span className={css.icon}>{step.icon}</span>}

			<div className={css.title}>
				<span className={css.id}>{id}</span>
				<span className={css.label}>{step.label}</span>
			</div>
		</div>
	);
};

export default Step;
